export const SearchIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
		/>
	</svg>
);

export const FilterIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.414A1 1 0 013 6.707V4z"
		/>
	</svg>
);

export const DownloadIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
		/>
	</svg>
);

export const XIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M6 18L18 6M6 6l12 12"
		/>
	</svg>
);

export const PlusIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M12 6v6m0 0v6m0-6h6m-6 0H6"
		/>
	</svg>
);

export const ChevronLeftIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M15 19l-7-7 7-7"
		/>
	</svg>
);

export const ChevronRightIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M9 5l7 7-7 7"
		/>
	</svg>
);

export const ChevronUpIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M5 15l7-7 7 7"
		/>
	</svg>
);

export const ChevronDownIcon = () => (
	<svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M19 9l-7 7-7-7"
		/>
	</svg>
);

// In your Icons.jsx file, add this export at the bottom:

export const locationData = {
	states: [
		"Alabama",
		"Alaska",
		"Arizona",
		"Arkansas",
		"California",
		"Colorado",
		"Connecticut",
		"Delaware",
		"Florida",
		"Georgia",
		"Hawaii",
		"Idaho",
		"Illinois",
		"Indiana",
		"Iowa",
		"Kansas",
		"Kentucky",
		"Louisiana",
		"Maine",
		"Maryland",
		"Massachusetts",
		"Michigan",
		"Minnesota",
		"Mississippi",
		"Missouri",
		"Montana",
		"Nebraska",
		"Nevada",
		"New Hampshire",
		"New Jersey",
		"New Mexico",
		"New York",
		"North Carolina",
		"North Dakota",
		"Ohio",
		"Oklahoma",
		"Oregon",
		"Pennsylvania",
		"Rhode Island",
		"South Carolina",
		"South Dakota",
		"Tennessee",
		"Texas",
		"Utah",
		"Vermont",
		"Virginia",
		"Washington",
		"West Virginia",
		"Wisconsin",
		"Wyoming",
	],

	dmas: [
		"Abilene - Sweetwater",
		"Albany, GA",
		"Albany - Schenectady - Troy",
		"Albuquerque - Santa Fe",
		"Alexandria, LA",
		"Alpena",
		"Amarillo",
		"Anchorage",
		"Atlanta",
		"Augusta",
		"Austin, TX",
		"Bakersfield",
		"Baltimore",
		"Bangor",
		"Baton Rouge",
		"Beaumont - Port Arthur",
		"Bend, OR",
		"Billings",
		"Biloxi - Gulfport",
		"Binghamton",
		"Birmingham (Anniston and Tuscaloosa)",
		"Bluefield - Beckley - Oak Hill",
		"Boise",
		"Boston (Manchester)",
		"Bowling Green",
		"Buffalo",
		"Burlington - Plattsburgh",
		"Butte - Bozeman",
		"Casper - Riverton",
		"Cedar Rapids - Waterloo & Dubuque",
		"Champaign & Springfield - Decatur",
		"Charleston-Huntington",
		"Charleston, SC",
		"Charlotte",
		"Charlottesville",
		"Chattanooga",
		"Cheyenne - Scottsbluff",
		"Chicago",
		"Chico - Redding",
		"Cincinnati",
		"Clarksburg - Weston",
		"Cleveland",
		"Colorado Springs - Pueblo",
		"Columbia - Jefferson City",
		"Columbia, SC",
		"Columbus, GA",
		"Columbus, OH",
		"Columbus - Tupelo - West Point",
		"Corpus Christi",
		"Dallas - Fort Worth",
		"Davenport - Rock Island - Moline",
		"Dayton",
		"Denver",
		"Des Moines - Ames",
		"Detroit",
		"Dothan",
		"Duluth - Superior",
		"Elmira",
		"El Paso",
		"Erie",
		"Eugene",
		"Eureka",
		"Evansville",
		"Fairbanks",
		"Fargo - Valley City",
		"Flint - Saginaw - Bay City",
		"Florence - Myrtle Beach",
		"Fort Myers - Naples",
		"Fort Smith - Fayetteville - Springdale - Rogers",
		"Fort Wayne",
		"Fresno - Visalia",
		"Gainesville",
		"Glendive",
		"Grand Junction - Montrose",
		"Grand Rapids - Kalamazoo - Battle Creek",
		"Great Falls",
		"Green Bay - Appleton",
		"Greensboro - High Point - Winston-Salem",
		"Greenville - New Bern - Washington",
		"Greenville - Spartansburg - Asheville - Anderson",
		"Greenwood - Greenville",
		"Harlingen - Weslaco - Brownsville - McAllen",
		"Harrisburg - Lancaster - Lebanon - York",
		"Harrisonburg",
		"Hartford & New Haven",
		"Hattiesburg - Laurel",
		"Helena",
		"Honolulu",
		"Houston",
		"Huntsville - Decatur (Florence)",
		"Idaho Falls - Pocatello",
		"Indianapolis",
		"Jackson, MS",
		"Jackson, TN",
		"Jacksonville, Brunswick",
		"Johnstown - Altoona",
		"Jonesboro",
		"Joplin - Pittsburg",
		"Juneau",
		"Kansas City",
		"Knoxville",
		"La Crosse - Eau Claire",
		"Lafayette, IN",
		"Lafayette, LA",
		"Lake Charles",
		"Lansing",
		"Laredo",
		"Las Vegas",
		"Lexington",
		"Lima",
		"Lincoln & Hastings - Kearney",
		"Little Rock - Pine Bluff",
		"Los Angeles",
		"Louisville",
		"Lubbock",
		"Macon",
		"Madison",
		"Mankato",
		"Marquette",
		"Medford - Klamath Falls",
		"Memphis",
		"Meridian",
		"Miami - Fort Lauderdale",
		"Milwaukee",
		"Minneapolis - Saint Paul",
		"Minot - Bismarck - Dickinson",
		"Missoula",
		"Mobile - Pensacola (Fort Walton Beach)",
		"Monroe - El Dorado",
		"Monterey - Salinas",
		"Montgomery (Selma)",
		"Nashville",
		"New Orleans",
		"New York",
		"Norfolk - Portsmouth - Newport News",
		"North Platte",
		"Odessa - Midland",
		"Oklahoma City",
		"Omaha",
		"Orlando - Daytona Beach - Melbourne",
		"Ottumwa - Kirksville",
		"Paducah - Cape Girardeau - Harrisburg - Mt Vernon",
		"Palm Springs",
		"Panama City",
		"Parkersburg",
		"Peoria - Bloomington",
		"Philadelphia",
		"Phoenix",
		"Pittsburgh",
		"Portland - Auburn",
		"Portland, OR",
		"Presque Isle",
		"Providence - New Bedford",
		"Quincy - Hannibal - Keokuk",
		"Raleigh - Durham (Fayetteville)",
		"Rapid City",
		"Reno",
		"Richmond - Petersburg",
		"Roanoke - Lynchburg",
		"Rochester - Mason City - Austin",
		"Rochester, NY",
		"Rockford",
		"Sacramento-Stockton-Modesto, CA",
		"Saint Joseph",
		"Saint Louis",
		"Salisbury",
		"Salt Lake City",
		"San Angelo",
		"San Antonio",
		"San Diego",
		"San Francisco - Oakland - San Jose",
		"Santa Barbara - Santa Maria - San Luis Obispo",
		"Savannah",
		"Seattle - Tacoma",
		"Sherman, TX - Ada, OK",
		"Shreveport",
		"Sioux City",
		"Sioux Falls (Mitchell)",
		"South Bend - Elkhart",
		"Spokane",
		"Springfield - Holyoke",
		"Springfield, MO",
		"Syracuse",
		"Tallahassee - Thomasville",
		"Tampa - Saint Petersburg (Sarasota)",
		"Terre Haute",
		"Toledo",
		"Topeka",
		"Traverse City - Cadillac",
		"Tri-Cities, TN-VA",
		"Tucson (Sierra Vista)",
		"Tulsa",
		"Twin Falls",
		"Tyler - Longview (Lufkin & Nacogdoches)",
		"Utica",
		"Victoria",
		"Waco - Temple - Bryan",
		"Washington DC (Hagerstown)",
		"Watertown",
		"Wausau - Rhinelander",
		"West Palm Beach - Fort Pierce",
		"Wheeling - Steubenville",
		"Wichita Falls & Lawton",
		"Wichita - Hutchinson",
		"Wilkes Barre - Scranton",
		"Wilmington",
		"Yakima - Pasco - Richland - Kennewick",
		"Youngstown",
		"Yuma - El Centro",
		"Zanesville",
	],

	congressional: [
		"Alabama 1st Congressional District",
		"Alabama 2nd Congressional District",
		"Alabama 3rd Congressional District",
		"Alabama 4th Congressional District",
		"Alabama 5th Congressional District",
		"Alabama 6th Congressional District",
		"Alabama 7th Congressional District",
		"Alaska At-large Congressional District",
		"American Samoa At-large Congressional District",
		"Arizona 1st Congressional District",
		"Arizona 2nd Congressional District",
		"Arizona 3rd Congressional District",
		"Arizona 4th Congressional District",
		"Arizona 5th Congressional District",
		"Arizona 6th Congressional District",
		"Arizona 7th Congressional District",
		"Arizona 8th Congressional District",
		"Arizona 9th Congressional District",
		"Arkansas 1st Congressional District",
		"Arkansas 2nd Congressional District",
		"Arkansas 3rd Congressional District",
		"Arkansas 4th Congressional District",
		"California 1st Congressional District",
		"California 2nd Congressional District",
		"California 3rd Congressional District",
		"California 4th Congressional District",
		"California 5th Congressional District",
		"California 6th Congressional District",
		"California 7th Congressional District",
		"California 8th Congressional District",
		"California 9th Congressional District",
		"California 10th Congressional District",
		"California 11th Congressional District",
		"California 12th Congressional District",
		"California 13th Congressional District",
		"California 14th Congressional District",
		"California 15th Congressional District",
		"California 16th Congressional District",
		"California 17th Congressional District",
		"California 18th Congressional District",
		"California 19th Congressional District",
		"California 20th Congressional District",
		"California 21st Congressional District",
		"California 22nd Congressional District",
		"California 23rd Congressional District",
		"California 24th Congressional District",
		"California 25th Congressional District",
		"California 26th Congressional District",
		"California 27th Congressional District",
		"California 28th Congressional District",
		"California 29th Congressional District",
		"California 30th Congressional District",
		"California 31st Congressional District",
		"California 32nd Congressional District",
		"California 33rd Congressional District",
		"California 34th Congressional District",
		"California 35th Congressional District",
		"California 36th Congressional District",
		"California 37th Congressional District",
		"California 38th Congressional District",
		"California 39th Congressional District",
		"California 40th Congressional District",
		"California 41st Congressional District",
		"California 42nd Congressional District",
		"California 43rd Congressional District",
		"California 44th Congressional District",
		"California 45th Congressional District",
		"California 46th Congressional District",
		"California 47th Congressional District",
		"California 48th Congressional District",
		"California 49th Congressional District",
		"California 50th Congressional District",
		"California 51st Congressional District",
		"California 52nd Congressional District",
		"California 53rd Congressional District",
		"Colorado 1st Congressional District",
		"Colorado 2nd Congressional District",
		"Colorado 3rd Congressional District",
		"Colorado 4th Congressional District",
		"Colorado 5th Congressional District",
		"Colorado 6th Congressional District",
		"Colorado 7th Congressional District",
		"Colorado 8th Congressional District",
		"Connecticut 1st Congressional District",
		"Connecticut 2nd Congressional District",
		"Connecticut 3rd Congressional District",
		"Connecticut 4th Congressional District",
		"Connecticut 5th Congressional District",
		"Delaware At-large Congressional District",
		"District of Columbia At-large Congressional District",
		"Florida 1st Congressional District",
		"Florida 2nd Congressional District",
		"Florida 3rd Congressional District",
		"Florida 4th Congressional District",
		"Florida 5th Congressional District",
		"Florida 6th Congressional District",
		"Florida 7th Congressional District",
		"Florida 8th Congressional District",
		"Florida 9th Congressional District",
		"Florida 10th Congressional District",
		"Florida 11th Congressional District",
		"Florida 12th Congressional District",
		"Florida 13th Congressional District",
		"Florida 14th Congressional District",
		"Florida 15th Congressional District",
		"Florida 16th Congressional District",
		"Florida 17th Congressional District",
		"Florida 18th Congressional District",
		"Florida 19th Congressional District",
		"Florida 20th Congressional District",
		"Florida 21st Congressional District",
		"Florida 22nd Congressional District",
		"Florida 23rd Congressional District",
		"Florida 24th Congressional District",
		"Florida 25th Congressional District",
		"Florida 26th Congressional District",
		"Florida 27th Congressional District",
		"Florida 28th Congressional District",
		"Georgia 1st Congressional District",
		"Georgia 2nd Congressional District",
		"Georgia 3rd Congressional District",
		"Georgia 4th Congressional District",
		"Georgia 5th Congressional District",
		"Georgia 6th Congressional District",
		"Georgia 7th Congressional District",
		"Georgia 8th Congressional District",
		"Georgia 9th Congressional District",
		"Georgia 10th Congressional District",
		"Georgia 11th Congressional District",
		"Georgia 12th Congressional District",
		"Georgia 13th Congressional District",
		"Georgia 14th Congressional District",
		"Guam At-large Congressional District",
		"Hawaii 1st Congressional District",
		"Hawaii 2nd Congressional District",
		"Idaho 1st Congressional District",
		"Idaho 2nd Congressional District",
		"Illinois 1st Congressional District",
		"Illinois 2nd Congressional District",
		"Illinois 3rd Congressional District",
		"Illinois 4th Congressional District",
		"Illinois 5th Congressional District",
		"Illinois 6th Congressional District",
		"Illinois 7th Congressional District",
		"Illinois 8th Congressional District",
		"Illinois 9th Congressional District",
		"Illinois 10th Congressional District",
		"Illinois 11th Congressional District",
		"Illinois 12th Congressional District",
		"Illinois 13th Congressional District",
		"Illinois 14th Congressional District",
		"Illinois 15th Congressional District",
		"Illinois 16th Congressional District",
		"Illinois 17th Congressional District",
		"Illinois 18th Congressional District",
		"Indiana 1st Congressional District",
		"Indiana 2nd Congressional District",
		"Indiana 3rd Congressional District",
		"Indiana 4th Congressional District",
		"Indiana 5th Congressional District",
		"Indiana 6th Congressional District",
		"Indiana 7th Congressional District",
		"Indiana 8th Congressional District",
		"Indiana 9th Congressional District",
		"Iowa 1st Congressional District",
		"Iowa 2nd Congressional District",
		"Iowa 3rd Congressional District",
		"Iowa 4th Congressional District",
		"Kansas 1st Congressional District",
		"Kansas 2nd Congressional District",
		"Kansas 3rd Congressional District",
		"Kansas 4th Congressional District",
		"Kentucky 1st Congressional District",
		"Kentucky 2nd Congressional District",
		"Kentucky 3rd Congressional District",
		"Kentucky 4th Congressional District",
		"Kentucky 5th Congressional District",
		"Kentucky 6th Congressional District",
		"Louisiana 1st Congressional District",
		"Louisiana 2nd Congressional District",
		"Louisiana 3rd Congressional District",
		"Louisiana 4th Congressional District",
		"Louisiana 5th Congressional District",
		"Louisiana 6th Congressional District",
		"Maine 1st Congressional District",
		"Maine 2nd Congressional District",
		"Maryland 1st Congressional District",
		"Maryland 2nd Congressional District",
		"Maryland 3rd Congressional District",
		"Maryland 4th Congressional District",
		"Maryland 5th Congressional District",
		"Maryland 6th Congressional District",
		"Maryland 7th Congressional District",
		"Maryland 8th Congressional District",
		"Massachusetts 1st Congressional District",
		"Massachusetts 2nd Congressional District",
		"Massachusetts 3rd Congressional District",
		"Massachusetts 4th Congressional District",
		"Massachusetts 5th Congressional District",
		"Massachusetts 6th Congressional District",
		"Massachusetts 7th Congressional District",
		"Massachusetts 8th Congressional District",
		"Massachusetts 9th Congressional District",
		"Michigan 1st Congressional District",
		"Michigan 2nd Congressional District",
		"Michigan 3rd Congressional District",
		"Michigan 4th Congressional District",
		"Michigan 5th Congressional District",
		"Michigan 6th Congressional District",
		"Michigan 7th Congressional District",
		"Michigan 8th Congressional District",
		"Michigan 9th Congressional District",
		"Michigan 10th Congressional District",
		"Michigan 11th Congressional District",
		"Michigan 12th Congressional District",
		"Michigan 13th Congressional District",
		"Michigan 14th Congressional District",
		"Minnesota 1st Congressional District",
		"Minnesota 2nd Congressional District",
		"Minnesota 3rd Congressional District",
		"Minnesota 4th Congressional District",
		"Minnesota 5th Congressional District",
		"Minnesota 6th Congressional District",
		"Minnesota 7th Congressional District",
		"Minnesota 8th Congressional District",
		"Mississippi 1st Congressional District",
		"Mississippi 2nd Congressional District",
		"Mississippi 3rd Congressional District",
		"Mississippi 4th Congressional District",
		"Missouri 1st Congressional District",
		"Missouri 2nd Congressional District",
		"Missouri 3rd Congressional District",
		"Missouri 4th Congressional District",
		"Missouri 5th Congressional District",
		"Missouri 6th Congressional District",
		"Missouri 7th Congressional District",
		"Missouri 8th Congressional District",
		"Montana 1st Congressional District",
		"Montana 2nd Congressional District",
		"Nebraska 1st Congressional District",
		"Nebraska 2nd Congressional District",
		"Nebraska 3rd Congressional District",
		"Nevada 1st Congressional District",
		"Nevada 2nd Congressional District",
		"Nevada 3rd Congressional District",
		"Nevada 4th Congressional District",
		"New Hampshire 1st Congressional District",
		"New Hampshire 2nd Congressional District",
		"New Jersey 1st Congressional District",
		"New Jersey 2nd Congressional District",
		"New Jersey 3rd Congressional District",
		"New Jersey 4th Congressional District",
		"New Jersey 5th Congressional District",
		"New Jersey 6th Congressional District",
		"New Jersey 7th Congressional District",
		"New Jersey 8th Congressional District",
		"New Jersey 9th Congressional District",
		"New Jersey 10th Congressional District",
		"New Jersey 11th Congressional District",
		"New Jersey 12th Congressional District",
		"New Mexico 1st Congressional District",
		"New Mexico 2nd Congressional District",
		"New Mexico 3rd Congressional District",
		"New York 1st Congressional District",
		"New York 2nd Congressional District",
		"New York 3rd Congressional District",
		"New York 4th Congressional District",
		"New York 5th Congressional District",
		"New York 6th Congressional District",
		"New York 7th Congressional District",
		"New York 8th Congressional District",
		"New York 9th Congressional District",
		"New York 10th Congressional District",
		"New York 11th Congressional District",
		"New York 12th Congressional District",
		"New York 13th Congressional District",
		"New York 14th Congressional District",
		"New York 15th Congressional District",
		"New York 16th Congressional District",
		"New York 17th Congressional District",
		"New York 18th Congressional District",
		"New York 19th Congressional District",
		"New York 20th Congressional District",
		"New York 21st Congressional District",
		"New York 22nd Congressional District",
		"New York 23rd Congressional District",
		"New York 24th Congressional District",
		"New York 25th Congressional District",
		"New York 26th Congressional District",
		"New York 27th Congressional District",
		"North Carolina 1st Congressional District",
		"North Carolina 2nd Congressional District",
		"North Carolina 3rd Congressional District",
		"North Carolina 4th Congressional District",
		"North Carolina 5th Congressional District",
		"North Carolina 6th Congressional District",
		"North Carolina 7th Congressional District",
		"North Carolina 8th Congressional District",
		"North Carolina 9th Congressional District",
		"North Carolina 10th Congressional District",
		"North Carolina 11th Congressional District",
		"North Carolina 12th Congressional District",
		"North Carolina 13th Congressional District",
		"North Carolina 14th Congressional District",
		"North Dakota At-large Congressional District",
		"Ohio 1st Congressional District",
		"Ohio 2nd Congressional District",
		"Ohio 3rd Congressional District",
		"Ohio 4th Congressional District",
		"Ohio 5th Congressional District",
		"Ohio 6th Congressional District",
		"Ohio 7th Congressional District",
		"Ohio 8th Congressional District",
		"Ohio 9th Congressional District",
		"Ohio 10th Congressional District",
		"Ohio 11th Congressional District",
		"Ohio 12th Congressional District",
		"Ohio 13th Congressional District",
		"Ohio 14th Congressional District",
		"Ohio 15th Congressional District",
		"Ohio 16th Congressional District",
		"Oklahoma 1st Congressional District",
		"Oklahoma 2nd Congressional District",
		"Oklahoma 3rd Congressional District",
		"Oklahoma 4th Congressional District",
		"Oklahoma 5th Congressional District",
		"Oregon 1st Congressional District",
		"Oregon 2nd Congressional District",
		"Oregon 3rd Congressional District",
		"Oregon 4th Congressional District",
		"Oregon 5th Congressional District",
		"Oregon 6th Congressional District",
		"Pennsylvania 1st Congressional District",
		"Pennsylvania 2nd Congressional District",
		"Pennsylvania 3rd Congressional District",
		"Pennsylvania 4th Congressional District",
		"Pennsylvania 5th Congressional District",
		"Pennsylvania 6th Congressional District",
		"Pennsylvania 7th Congressional District",
		"Pennsylvania 8th Congressional District",
		"Pennsylvania 9th Congressional District",
		"Pennsylvania 10th Congressional District",
		"Pennsylvania 11th Congressional District",
		"Pennsylvania 12th Congressional District",
		"Pennsylvania 13th Congressional District",
		"Pennsylvania 14th Congressional District",
		"Pennsylvania 15th Congressional District",
		"Pennsylvania 16th Congressional District",
		"Pennsylvania 17th Congressional District",
		"Pennsylvania 18th Congressional District",
		"Puerto Rico At-large Congressional District",
		"Rhode Island 1st Congressional District",
		"Rhode Island 2nd Congressional District",
		"South Carolina 1st Congressional District",
		"South Carolina 2nd Congressional District",
		"South Carolina 3rd Congressional District",
		"South Carolina 4th Congressional District",
		"South Carolina 5th Congressional District",
		"South Carolina 6th Congressional District",
		"South Carolina 7th Congressional District",
		"South Dakota At-large Congressional District",
		"Tennessee 1st Congressional District",
		"Tennessee 2nd Congressional District",
		"Tennessee 3rd Congressional District",
		"Tennessee 4th Congressional District",
		"Tennessee 5th Congressional District",
		"Tennessee 6th Congressional District",
		"Tennessee 7th Congressional District",
		"Tennessee 8th Congressional District",
		"Tennessee 9th Congressional District",
		"Texas 1st Congressional District",
		"Texas 2nd Congressional District",
		"Texas 3rd Congressional District",
		"Texas 4th Congressional District",
		"Texas 5th Congressional District",
		"Texas 6th Congressional District",
		"Texas 7th Congressional District",
		"Texas 8th Congressional District",
		"Texas 9th Congressional District",
		"Texas 10th Congressional District",
		"Texas 11th Congressional District",
		"Texas 12th Congressional District",
		"Texas 13th Congressional District",
		"Texas 14th Congressional District",
		"Texas 15th Congressional District",
		"Texas 16th Congressional District",
		"Texas 17th Congressional District",
		"Texas 18th Congressional District",
		"Texas 19th Congressional District",
		"Texas 20th Congressional District",
		"Texas 21st Congressional District",
		"Texas 22nd Congressional District",
		"Texas 23rd Congressional District",
		"Texas 24th Congressional District",
		"Texas 25th Congressional District",
		"Texas 26th Congressional District",
		"Texas 27th Congressional District",
		"Texas 28th Congressional District",
		"Texas 29th Congressional District",
		"Texas 30th Congressional District",
		"Texas 31st Congressional District",
		"Texas 32nd Congressional District",
		"Texas 33rd Congressional District",
		"Texas 34th Congressional District",
		"Texas 35th Congressional District",
		"Texas 36th Congressional District",
		"Texas 37th Congressional District",
		"Texas 38th Congressional District",
		"Utah 1st Congressional District",
		"Utah 2nd Congressional District",
		"Utah 3rd Congressional District",
		"Utah 4th Congressional District",
		"Vermont At-large Congressional District",
		"Virgin Islands At-large Congressional District",
		"Virginia 1st Congressional District",
		"Virginia 2nd Congressional District",
		"Virginia 3rd Congressional District",
		"Virginia 4th Congressional District",
		"Virginia 5th Congressional District",
		"Virginia 6th Congressional District",
		"Virginia 7th Congressional District",
		"Virginia 8th Congressional District",
		"Virginia 9th Congressional District",
		"Virginia 10th Congressional District",
		"Virginia 11th Congressional District",
		"Washington 1st Congressional District",
		"Washington 2nd Congressional District",
		"Washington 3rd Congressional District",
		"Washington 4th Congressional District",
		"Washington 5th Congressional District",
		"Washington 6th Congressional District",
		"Washington 7th Congressional District",
		"Washington 8th Congressional District",
		"Washington 9th Congressional District",
		"Washington 10th Congressional District",
		"West Virginia 1st Congressional District",
		"West Virginia 2nd Congressional District",
		"West Virginia 3rd Congressional District",
		"Wisconsin 1st Congressional District",
		"Wisconsin 2nd Congressional District",
		"Wisconsin 3rd Congressional District",
		"Wisconsin 4th Congressional District",
		"Wisconsin 5th Congressional District",
		"Wisconsin 6th Congressional District",
		"Wisconsin 7th Congressional District",
		"Wisconsin 8th Congressional District",
		"Wyoming At-large Congressional District",
	],
};
